import { useSelector } from 'react-redux';
import {
	getCountriesData,
	getUserCurrentCity,
} from '@/stores/slices/userSlice';
import React, { useState } from 'react';
import { SelectCountry } from '@/components/ui';
import useLadyService from '@/services/LadyService';

const SelectCity = () => {
	const { lang } = useLadyService();
	const [currentActive, setCurrentActive] = useState('');

	const countriesData = useSelector(getCountriesData);
	const currentCity = useSelector(getUserCurrentCity);
	const countryEntries = Array.isArray(countriesData)
  	? countriesData.flatMap((item) => Object.entries(item || {}))
  	: [];

	const isJsdom =
		typeof window !== 'undefined' &&
		window.navigator.userAgent.includes('jsdom');

	if (!isJsdom) {
		return (
			<SelectCountry
				data={countriesData}
				name={'city-create'}
				clazz={`button select-city no-outline`}
				arrowSize={'m'}
				type={'flag'}
				defaultTitle={currentCity.title}
				currentActiveIndex={currentActive}
				isMain={true}
				activeCountry={currentCity.icon}
				setActive={setCurrentActive}
				selectDistrict={true}
			/>
		);
	} else {
		return (
			<p>
				{countryEntries.map(([countryCode, country]) => {
					const countrySlug = country?.slug || countryCode;
					const countryHref =
						lang === 'en' && countrySlug === 'czechia'
							? '/'
							: `/${lang}/${countrySlug}`;

					return (
						<React.Fragment key={countryCode}>
							<a href={countryHref}>
								<b>{country?.name || countrySlug}</b>
							</a>
							<span>{`: `}</span>
							{(country?.cities || []).map((city) => {
								const cityName = city.title || city.name;
								const districts = city.districts || [];

								return (
									<React.Fragment key={city.id || city.slug}>
										<a href={`/${lang}/${city.slug}`}>
											{districts.length > 0 ? (
												<b>{cityName}</b>
											) : (
												cityName
											)}
										</a>
										{districts.length > 0 && <span>{`: `}</span>}
										{districts.map((district) => (
											<React.Fragment
												key={district.id || district.slug}
											>
												<a
													href={`/${lang}/${city.slug}_${district.slug}`}
												>
													{`${cityName} - ${district.name}`}
												</a>
												<span>{` `}</span>
											</React.Fragment>
										))}
										{districts.length > 0 && <br />}
										{districts.length === 0 && <span>{` `}</span>}
									</React.Fragment>
								);
							})}
							<br />
						</React.Fragment>
					);
				})}
			</p>
		);
	}
};

export default SelectCity;

// deploy
